import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchParentDashboardList = createAsyncThunk("fetchParentDashboardList", async () => {
	const token = localStorage.getItem("auth_token");

	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};

	const response = await axiosHttp.get(`analytics/dashboard/main/list`, config);

	return response.data.data;
});

const ParentDashboardListSlice = createSlice({
	name: "ParentDashboardListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchParentDashboardList.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchParentDashboardList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchParentDashboardList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default ParentDashboardListSlice.reducer;
